/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardContent, Typography, Grid } from '@mui/material';
import DataTable from '../../../modules/dataTable/DataTable/DataTable';
import { AUTH_ZERO_AUDIENCE } from '../../../modules/utils/env';
import columns from '../constants/columns';
import { RfidsAutoBulkContext } from '../contexts/RfidAutoBulkContext';
import { RfidAutoBulk } from '../model';
import { MachinesContext } from '../../../modules/machinesAdminManagement/contexts/MachinesContext';
import RfidAutoBulkFilterBar from '../components/RfidAutoBulkFilterBar';

const RfidAutoBulkList: React.FunctionComponent = () => {
  const [initialDataLoaded, setDataLoaded] = React.useState(false);
  const [fitlerBarActive, setFitlerBarActive] = React.useState(true);

  const {
    fetchRfidsAutoBulk,
    rfids,
    setCreatingPage,
    setDetailPage,
    setActiveRfidAutoBulk,
    activeRfidAutoBulk,
    activeMachine,
    setActiveMachine,
  } = React.useContext(RfidsAutoBulkContext);
  const { fetchAutoBulkMachines, autoBulkMachines, machinesLoading } = React.useContext(MachinesContext);

  React.useEffect(() => {
    const getMachines = async () => {
      if (!initialDataLoaded) {
        setDataLoaded(true);
        fetchAutoBulkMachines();
      }
    };

    getMachines();
  }, [initialDataLoaded, setDataLoaded, fetchRfidsAutoBulk]);

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Typography variant="h1" component="h1">
            RFID Management
          </Typography>
          <br />
        </Grid>
      </Grid>
      <br />
      {fitlerBarActive && (
        <Grid justifyContent="space-between" container>
          <Grid item md={12}>
            <RfidAutoBulkFilterBar machineChoices={autoBulkMachines} machineChoicesLoading={machinesLoading} />
            <br />
          </Grid>
        </Grid>
      )}
      <br />
      <>
        <Card>
          <CardContent>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Typography variant="h1" component="h1" style={{ fontSize: '22px' }}>
                  RFID List
                </Typography>
              </Grid>

              <Button
                variant="contained"
                color="primary"
                disabled={
                  activeMachine?.value === 'Select A Machine' ||
                  activeMachine?.value === undefined ||
                  activeMachine?.online_status === 'offline'
                }
                onClick={() => {
                  setCreatingPage(true);
                  setFitlerBarActive(false);
                }}
              >
                Create Rfid
              </Button>
            </Grid>
            {activeMachine && activeMachine?.value !== 'Select A Machine' ? (
              <DataTable
                noHeader
                columns={columns}
                data={rfids}
                defaultSortField=""
                defaultSortAsc
                striped
                onRowClicked={(row: RfidAutoBulk) => {
                  setActiveRfidAutoBulk(row as any);
                  setDetailPage(true);
                  setFitlerBarActive(false);
                  setActiveMachine(activeMachine);
                }}
                highlightOnHover
                pointerOnHover
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50]}
              />
            ) : (
              <Grid container alignItems="center" justifyContent="center">
                <Typography variant="h2" component="h2" style={{ marginTop: 15 }}>
                  Please select a machine to view details.
                </Typography>
              </Grid>
            )}
          </CardContent>
          <br />
        </Card>
      </>
    </>
  );
};

export default RfidAutoBulkList;
